<div class="not-found-page">
    <img src="assets/images/img_page_not_found.png"
         alt="Page not found"
         class="not-found-page__img">
    <div class="not-found-page__text">Page not found</div>
</div>
